import { Components, Theme } from "@mui/material";

export const MuiCardContent: Components<Theme>["MuiCardContent"] = {
  defaultProps: {
    sx: {
      background:
        "repeating-linear-gradient(-45deg,  #fff 0px 5px, #FBFBFB  5px 6px)",
      borderRadius: "1rem",
      padding: "1rem",
    },
  },
};
